import api from '../clients/axios';

const resource = '/api/v1/charlie-blacklist';

export default {
  async getAllBlackList(params) {
    const response = await api.get(`${resource}`, { params });
    return response;
  },
  async createBlackListItem(body) {
    const response = await api.post(`${resource}`, body);
    return response;
  },
  async updateBlackListItem(id, body) {
    const response = await api.patch(`${resource}/${id}`, body);
    return response;
  },
  async deleteBlackListItem(id) {
    const response = await api.delete(`${resource}/${id}`);
    return response;
  },
};
